.root {
  align-items: center;
  background: var(--color-border);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  height: 22px;
  padding: 2px;
  transition: background 0.15s ease;
  width: 40px;
}

.root-is-checked {
  background: var(--color-primary);
}

.root-is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.thumb {
  background: var(--color-surface);
  border-radius: 50%;
  height: 18px;
  transition: transform 0.15s ease;
  width: 18px;
}

.root-is-checked .thumb {
  transform: translateX(18px);
}
